import { RefObject, useEffect, useState } from 'react';

function useSticky(elementRef: RefObject<HTMLElement>, offsetTop?: number) {
    const [isSticky, setSticky] = useState(false);

    useEffect(() => {
        // 更新元素的位置
        const updatePosition = () => {
            // 获取元素距离窗口顶部的距离
            const elementTop = elementRef.current?.getBoundingClientRect().top || 0;
            const windowTop = window.pageYOffset || document.documentElement.scrollTop;
            setSticky(windowTop > elementTop);
        };

        // 监听scroll事件
        window.addEventListener('scroll', updatePosition);

        return () => {
            // 在组件卸载时移除scroll事件监听
            window.removeEventListener('scroll', updatePosition);
        };
    }, [elementRef]);

    // 设定元素的样式
    useEffect(() => {
        if (!elementRef.current) {
            return;
        }

        if (isSticky) {
            elementRef.current.style.position = 'fixed';
            elementRef.current.style.top = `${offsetTop || 0}`;
            elementRef.current.style.margin = '0';
        } else {
            elementRef.current.style.position = '';
            elementRef.current.style.top = '';
            elementRef.current.style.margin = '';
        }
    }, [elementRef, isSticky]);
    return isSticky;
}

export default useSticky;
